<template>
  <div contenteditable="true" @input="updateHTML"/>
</template>

<script>
export default {
  name: 'HtmlTextarea',
  /* props:['value'], */
  props:{
    value: {
      type: Object,
      default: null
    },
  },
  mounted: function () {
      this.$el.innerHTML = this.value;
    },
  methods: {
    updateHTML: function(e) {
      this.$emit('input', e.target.innerHTML);
    }
  }
}
</script>

<style lang="css" scoped>
  div[contenteditable] {
    border: 1px solid lightblue;
    text-align: left;
    padding: 25px 10px 25px 15px;
    margin: 5px 5px 5px 0px;
  }
</style>